import { Empty, Skeleton } from "antd";
import { ReactNode } from "react";
import QueryRetry from "../QueryRetry";
import { CardStatus } from "./cardStatus";

interface WidgetStateProps {
	status: CardStatus;
	emptyText: string;
	/** Shown on a 403; the selects only offer accessible tenants, so it is rare. */
	forbiddenText?: string;
	onRetry?: () => void;
	/** The source limit was reached, so the counts may be partial. */
	truncated?: boolean;
	children?: ReactNode;
}

/** Loading, error, no-access and empty states, or the content when ready. */
function WidgetState({
	status,
	emptyText,
	forbiddenText = "You don't have access to this data.",
	onRetry,
	truncated = false,
	children,
}: WidgetStateProps) {
	switch (status) {
		case "loading":
			return (
				<div className="dashboard-card__state" aria-busy="true">
					<Skeleton active title={false} paragraph={{ rows: 4 }} />
				</div>
			);
		case "error":
			return (
				<div className="dashboard-card__state">
					<QueryRetry queryKey={null} refetch={onRetry} />
				</div>
			);
		case "forbidden":
			return <div className="dashboard-card__state">{forbiddenText}</div>;
		case "all-tenants-unavailable":
			return (
				<div className="dashboard-card__state">
					The All tenants view isn&apos;t available. Choose a single tenant
					instead.
				</div>
			);
		case "empty":
			return (
				<div className="dashboard-card__state">
					<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={emptyText} />
				</div>
			);
		case "ready":
			return (
				<>
					{children}
					{truncated && (
						<p className="dashboard-card__note">
							Partial data: the source limit was reached.
						</p>
					)}
				</>
			);
	}
}

export default WidgetState;
